import React from 'react'
import {
  AddressFields,
  AmountAndRecurringSelection,
  CompanyFields,
  DonationFormCaptcha,
  GeneralError,
  HeroImage,
  HolderFields,
  HolderHeadline,
  MatchingFundBanner,
  MessageField,
  OfflineMessage,
  PaymentMethodError,
  PaymentMethodSelection,
  PlatformNewsletterCheckbox,
  SSLLogo,
  StripeCCFields,
  StripeSEPADebitFields,
  SubmitButton,
  Summary,
  Terms,
  TrustLogos,
} from '../shared'
import { ClientFormComp, WrappingDivsProps } from './types'
import { Debug } from '../debug'
import { Form, connect } from 'formik'
import { FormProps, FormValues } from 'donate/types'
import { ProhibitedNotice } from '../platform/prohibited_notice'
import { TrustedHtml } from 'shared'

//TODO: Improve types
export const ClientForm: ClientFormComp = connect<FormProps, FormValues>(({ display, config }) => {
  if (config.donationsProhibited) {
    return (
      <WrappingDivs>
        <HeroImage {...display} />
        <ProhibitedNotice />
      </WrappingDivs>
    )
  }

  return (
    <WrappingDivs
      ultimatelySubjectToLevy={display.ultimatelySubjectToLevy}
      transactionCostNotice={display.transactionCostNotice}
    >
      <HeroImage {...display} />
      <Form>
        <div className="donate-form-content generic-popover-constraints">
          <GeneralError />
          <OfflineMessage />

          <AmountAndRecurringSelection />

          <MatchingFundBanner config={config} display={display} />

          <div className="form-fields">
            <PaymentMethodSelection />
            <HolderHeadline />
            <HolderFields />
            <CompanyFields />
            <AddressFields required />
            <MessageField config={config} />
            <StripeCCFields />
            <StripeSEPADebitFields />
            <PaymentMethodError />
            <Summary config={config} display={display} />
            <PlatformNewsletterCheckbox />
            <SubmitButton config={config} />
            <Terms />
            <TrustLogos />
            <DonationFormCaptcha config={config} />
          </div>
        </div>
      </Form>
      <Debug />
    </WrappingDivs>
  )
})

const WrappingDivs = ({ children, ultimatelySubjectToLevy, transactionCostNotice }: WrappingDivsProps): JSX.Element => (
  <div className="donate-form platform-donations-new">
    <div className="container donate-form">
      <div className="row" style={{ alignItems: 'flex-start' }}>
        <div className="col-md-16 offset-md-1 bg-white wrapper donate-form-wrapper">{children}</div>
        <div className="client-donations-transaction-cost-sidebar col-md-6 bg-white hidden desktop:block px-3 py-6 text-center text-muted">
          <OneHundredPercentClaim
            ultimatelySubjectToLevy={ultimatelySubjectToLevy}
            transactionCostNotice={transactionCostNotice}
          />

          <div className="mb-6 pb-6 border-b border-gray-200">✔ Spendenbescheinigung</div>

          <SSLLogo className="h-18" />
        </div>
      </div>
    </div>
  </div>
)

const OneHundredPercentClaim = ({
  ultimatelySubjectToLevy,
  transactionCostNotice,
}: WrappingDivsProps): JSX.Element | null => {
  if (ultimatelySubjectToLevy) return null
  return (
    <>
      <img
        src="data:image/png;base64,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"
        width={66}
        height={57}
        alt=""
      />

      <div className="mt-3 mb-1">
        <strong>{i18n.t('donate.client.one_hundred_percent_claim')}</strong>
      </div>

      <div className="client-transaction-cost-notice pb-6 mb-6 border-b border-gray-200">
        <TrustedHtml as="small" value={transactionCostNotice ?? ''} />
      </div>
    </>
  )
}
